import React, {useState} from 'react'
import {Button, message, Modal, Result} from "antd"
import {EyeInvisibleOutlined, EyeOutlined} from "@ant-design/icons"
import {postGrouponState} from "../../../api/groupon"
import {useGroupBuyingContext} from "../store/useGroupBuyingContext"

const GroupBuyingOpen = () => {
    const [isShow, setIsShow] = useState(false)
    const [isConfirmLoading, setIsConfirmLoading] = useState(false)

    const {grouponSettingState, grouponListState} = useGroupBuyingContext()

    const handleClick = () => {
        setIsShow(true)
    }
    const handleCancel = () => {
        setIsShow(false)
    }

    const handleUpDateGrouponState = async () => {
        setIsConfirmLoading(true)
        const setting = grouponSettingState.data
        const data = {
            ...setting,
            useGroupon: !setting.useGroupon
        }
        await postGrouponState(data).then(res => {
            if (res.status !== 1) {
                message.error(`修改俱乐部设置失败：${res.detail}`)
            } else {
                message.success('修改成功，团购已' + (res.data.useGroupon ? '关闭' : '开启') + '！')
            }
        }).finally(async () => {
            setIsConfirmLoading(false)
            setIsShow(false)
            await grouponListState.reFetch()
            await grouponSettingState.reFetch()
        })

    }


    return (
        <div>
            <Button
                type={"primary"}
                icon={grouponSettingState.data.useGroupon ? <EyeInvisibleOutlined/> : <EyeOutlined/>}
                danger={grouponSettingState.data.useGroupon }
                onClick={handleClick}
                loading={isConfirmLoading}
            >
                {grouponSettingState.data.useGroupon  ? "关闭团购" : "开启团购"}
            </Button>
            <Modal
                open={isShow}
                onCancel={handleCancel}
                onOk={handleUpDateGrouponState}
                title={grouponSettingState.data.useGroupon ? "关闭团购" : "开启团购"}
                confirmLoading={isConfirmLoading}
            >
                <Result title={grouponSettingState.data.useGroupon ? "确定关闭团购吗？" : "确定开启团购吗？"}
                        status={"warning"}/>
            </Modal>
        </div>
    )
}

export default GroupBuyingOpen


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingOpen.js